import { makeStyles } from '@material-ui/core';
import rootenyLogo from '../../assets/rooteny-logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 42,
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      src={rootenyLogo}
      alt="Rooteny IbyraHub"
    />
  );
};
